module.exports = "/images/vendor/desiigner-svg/svg/ui/wreath.svg?5c0b5e8e1a461ad750778a89090053b9";